import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { MobileFacet } from '../../components/mobile-facet/mobile-facet'
import { ariaLabel } from '../../utils/form-utilities'
import {
    EditTermsButton,
    ResetToLowestMonthlyPriceButton,
} from '../../components/leasing-terms-toggle/leasing-terms-toggle'
import { SearchFiltersToggle } from '../../components/search-filters-toggle/search-filters-toggle'

export const LeaseMinMonthlyPrice = withFilterContext(FilterName.min_lease_monthly_price, SearchFiltersDropdown, {
    title: 'Min monthly price',
    ariaLabel: ariaLabel.monthlyPrice.min,
})

export const LeaseMaxMonthlyPrice = withFilterContext(FilterName.max_lease_monthly_price, SearchFiltersDropdown, {
    title: 'Max monthly price',
    ariaLabel: ariaLabel.monthlyPrice.max,
})

export const LeaseMinMonthlyPriceExVat = withFilterContext(
    FilterName.min_lease_monthly_price_ex_vat,
    SearchFiltersDropdown,
    {
        title: 'Min monthly price',
        ariaLabel: ariaLabel.monthlyPrice.min,
    }
)

export const LeaseMaxMonthlyPriceExVat = withFilterContext(
    FilterName.max_lease_monthly_price_ex_vat,
    SearchFiltersDropdown,
    {
        title: 'Max monthly price',
        ariaLabel: ariaLabel.monthlyPrice.max,
    }
)

export const LeasingTerm = withFacetContext(
    FacetName.leasing,
    withFilterContext(FilterName.term, SearchFiltersToggle, {
        title: 'How long would you like the vehicle for (months)',
    })
)
export const LeasingDeposit = withFacetContext(
    FacetName.leasing,
    withFilterContext(FilterName.deposit, SearchFiltersToggle, {
        title: 'How much would you like to pay upfront (months)',
    })
)
export const LeasingYearlyMileage = withFacetContext(
    FacetName.leasing,
    withFilterContext(FilterName.yearly_mileage, SearchFiltersDropdown, {
        title: "What's your expected annual mileage?",
    })
)
export const LeasingPriceExpander = withFacetContext(FacetName.lease_monthly_price, MobileFacet)
export const LeasingPriceExVatExpander = withFacetContext(FacetName.lease_monthly_price_ex_vat, MobileFacet)

export const EditTerms = withFacetContext(FacetName.leasing, withFilterContext(FilterName.term, EditTermsButton))

export const ResetToLowestMonthlyPrice = withFacetContext(
    FacetName.leasing,
    withFilterContext(FilterName.term, ResetToLowestMonthlyPriceButton)
)
